import React from 'react';
import HeroSection from './HeroSection';
import SolutionsSection from './SolutionsSection';
import FeaturesSection from './FeaturesSection';
//import PartnersScroll from './PartnersScroll';
import TrustedPartners from './TrustedPartners';



const HomeHero = () => {
  return (
    <div>
      <HeroSection />
      <SolutionsSection/>
      <FeaturesSection/>
      <TrustedPartners/>
      {/* <QuestionComponent /> */}
    </div>
  );
};

export default HomeHero;
